import { ComponentProps, PropsWithChildren } from "react";

import { cn } from "@aircall/ds";

export function EvaluationComment({
  children,
  className,
  ...props
}: PropsWithChildren<ComponentProps<"div">>) {
  return (
    <div
      className={cn("flex items-center rounded-lg bg-muted p-2", className)}
      {...props}
    >
      <p className="text-base font-normal">{children}</p>
    </div>
  );
}
